var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanelIngredient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-examples",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-30.000000, -631.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bits/Ingredient/-\\uD83D\\uDCF1/White",
    transform: "translate(20.000000, 619.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Dot",
    transform: "translate(10.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colours/Primary/Dot/Blue",
    fill: "#41A6C4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C23.2842712,-1.52179594e-15 30,6.71572875 30,15 C30,23.2842712 23.2842712,30 15,30 C6.71572875,30 1.01453063e-15,23.2842712 0,15 C-1.01453063e-15,6.71572875 6.71572875,1.52179594e-15 15,0 Z",
    id: "Rectangle-8-Copy-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons/Info/Light",
    transform: "translate(5.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33333333,16.3437412 L9.29395218,16.3437412 L9.29395218,9.41265823 L5.33333333,9.41265823 L5.33333333,6.68973277 L12.2194093,6.68973277 L12.2194093,16.3437412 L16.3825598,16.3437412 L16.3825598,19.0666667 L5.33333333,19.0666667 L5.33333333,16.3437412 Z M8.75386779,3.32320675 C8.75386779,2.81162426 8.92639302,2.3743103 9.27144866,2.01125176 C9.6165043,1.64819322 10.0965745,1.46666667 10.7116737,1.46666667 C11.3417753,1.46666667 11.8443488,1.64819322 12.2194093,2.01125176 C12.5944698,2.3743103 12.7819972,2.81162426 12.7819972,3.32320675 C12.7819972,3.8512919 12.5944698,4.28448026 12.2194093,4.62278481 C11.8443488,4.96108936 11.3417753,5.1302391 10.7116737,5.1302391 C10.0965745,5.1302391 9.6165043,4.96108936 9.27144866,4.62278481 C8.92639302,4.28448026 8.75386779,3.8512919 8.75386779,3.32320675 Z",
    id: "i"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelIngredient);
export default __webpack_public_path__ + "static/media/panel-ingredient.33b4f4afe2d9cddc221e7059dbb13886.svg";
export { ForwardRef as ReactComponent };